import styled from 'styled-components';

import { theme } from '@notino/react-styleguide-v20';

import { ImageLink } from '@sharedComponents/Images';

export const Product = styled.div`
  display: flex;
  flex-wrap: nowrap;
  margin: 0.625rem 0;
`;

export const Image = styled(ImageLink)`
  display: inline-block;
  width: 3.125rem;
  height: 3.125rem;
  min-width: 3.125rem;
  margin-right: 1.25rem;
  margin-left: 0.4375rem;
  vertical-align: middle;
  text-align: center;
`;

export const ItemInfo = styled.div`
  display: inline-block;
  padding-top: 0.4375rem;
  vertical-align: middle;
  font-size: 0.875rem;
  line-height: 1.125rem;
`;

export const ItemSubName = styled.span`
  display: block;
  font-size: 0.75rem;
  color: ${theme.color.text.secondary};
`;
